import { FC } from 'react';

import { ServicesIntroductionType } from '@/types';

interface IServicesIntroductionProps {
  introduction: ServicesIntroductionType;
}

const ServicesIntroduction: FC<IServicesIntroductionProps> = ({
  introduction: { text },
}) => {
  return (
    <>
      {text.map((i, id) => (
        <p key={id} className={` mb-4 custom-p `}>
          {i}
        </p>
      ))}
    </>
  );
};

export default ServicesIntroduction;
